var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BulmaAccordion',{attrs:{"dropdown":"","icon":'caret',"caretAnimation":{
    duration: '.6s',
    timerFunc: 'ease-in-out'
},"slide":{
    duration: '.9s',
    timerFunc: 'ease'
}}},_vm._l((_vm.accordionitem.accordionLists),function(accordion,i){return _c('HiwAccordionItems',{key:i,attrs:{"accordion":accordion}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }